import {createSlice, type PayloadAction} from '@reduxjs/toolkit'

import type {TabId} from '../../../types'

export const projectTab = createSlice({
  name: 'projectTab',
  initialState: null as TabId | null,
  reducers: {
    change: (_, action: PayloadAction<TabId | null>) => action.payload,
  },
})
